module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-card-title', {
    staticClass: "pb-0 px-4 layout row wrap"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.header.autoJobs))]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "ml-3 mt-0",
    attrs: {
      "color": "primary",
      "label": _vm.$lang.labels.showActive,
      "hide-details": ""
    },
    model: {
      value: (_vm.showActive),
      callback: function($$v) {
        _vm.showActive = $$v
      },
      expression: "showActive"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "min-w max-w",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.showActive ? _vm.activeAutojobs : _vm.allAutojobs,
      "search": _vm.search,
      "loading": _vm.allAutojobs.length === 0,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.jobName))]), _vm._v(" "), _c('td', {
          staticClass: "min-w"
        }, [_vm._v(_vm._s(props.item.jobDesc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.lastExecutedOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.nextPlannedExecutionOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "primary elevation-1",
          on: {
            "click": function($event) {
              return _vm.changeStatus(props.item)
            }
          }
        }, [_vm._v(_vm._s(props.item.status === 'active' ? _vm.$lang.actions.deactivate : _vm.$lang.actions.activate))])], 1)]
      }
    }])
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n        Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83d96f64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoJob/AutoJob.vue
// module id = 422
// module chunks = 35